const log = {
    invalid_type: 'Type de journalisation invalide.',
};
export default log;
